import { bootstrapApplication } from '@angular/platform-browser';
import { isDevMode } from '@angular/core';
import { appConfig, logEvent } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LOCAL_STORAGE_KEY_RESET_STORAGE, LOCAL_STORAGE_KEY_USERNAME, VERSION } from './app/const';
import { SETTINGS_KEY_DISMISS_TUTORIALS } from './app/services/settings.service';
import * as Sentry from "@sentry/angular";
import { poe2 } from './game';

if (!isDevMode()) {
  Sentry.init({
    dsn: poe2 ? "https://a9f6d506bc096d96d0ffc7839b372647@o4510890353950720.ingest.de.sentry.io/4510890355589200"
      : "https://665336f43770dff178f8b8e8e95d9f5f@o4510890353950720.ingest.de.sentry.io/4510958147010640",
    release: VERSION,
    enableLogs: true
  });

  Sentry.setTag('version', VERSION);

  const username = localStorage.getItem(LOCAL_STORAGE_KEY_USERNAME);
  if (username) {
    Sentry.setUser({
      username: username,
      id: username,
    });
  }
}

function resetLocalStorage() {
  if (localStorage.getItem(LOCAL_STORAGE_KEY_RESET_STORAGE)) return; // Don't loop if this doesn't fix the problem
  localStorage.clear();
  localStorage.setItem(LOCAL_STORAGE_KEY_RESET_STORAGE, '1');
  localStorage.setItem(SETTINGS_KEY_DISMISS_TUTORIALS, '1');
  window.location.reload();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    logEvent('Bootstrap Error', err.toString(), err.stack?.split('\n')[1] || '');
    resetLocalStorage();
    throw err;
  });
